function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function getNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1) ) + min;
}

theme.arraySuffle = function(array)
{
    var currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];

        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};

theme.updateCartQty = function (callback)
{
    fetch('/cart.js')
    .then(function(response){
        return response.json();
    })
    .then(function (json) {
        if(json.items){
            jQuery('.cart-qty').html(json.items.length);
        }

        if (typeof callback === 'function') {
            callback(json);
        }

        return json;
    });
};

var galleryPopupTmplOptions = {
    getDescription: function () {

        if (this.data.template_suffix == 'shopart.severalcandies') {
            return '<p>From cheeky sayings to punchy color palettes, our playful art is designed to spark conversation and induce your candy cravings. It’s the perfect piece for any modern space…and of course, anyone with a sweet tooth.</p>';
        }

        return this.data.body_html;
    }
};


function blogPressTitlesEqualHeight()
{
    var blogPresItemsTitles = jQuery(".blog-press-wrapper .item-title");

    if(blogPresItemsTitles.length)
    {
        var maxHeight = Math.max.apply(null, blogPresItemsTitles.map(function (){
            return jQuery(this).height();
        }).get());

        blogPresItemsTitles.css('min-height', maxHeight);
    }
}

function galleryPopupClose()
{
    jQuery('#productPopupViewer').html(jQuery('#galleryPopupLoader').html()).hide();
    $(document.body).removeClass('none-vis');
}

function showTooltipAddToCart() 
{
    if ($('.tooltip-add-to-cart').length > 0) {
        $('.tooltip-add-to-cart').fadeIn(400).delay(1000).fadeOut(400);
    }
}

jQuery(document).ready(function($){

    theme.updateCartQty();
  
  	blogPressTitlesEqualHeight();

    $('.acc-list .acc-list-item').each(function () {
        if($(this).is('.opened')){
            $(this).find('.acc-item-content').show();
            $(this).addClass('open');
        }
    });

    $('.acc-list > .acc-list-item > .acc-item-head').click(function () {
        var item = $(this).closest('.acc-list-item');
        if(item.is('.open')){
            $(this).next('.acc-item-content').slideUp(300);
            item.removeClass('open');
        }else{
            $(this).next('.acc-item-content').slideDown(300);
            item.addClass('open');
        }
    });

    $(document).on('addToCart', function (e, data) {
        if(data.items){
            $('.cart-qty').html(data.items.length);
        }

        var product_form_cart_submit = $('#product_form_cart_submit, .product-toolbar .product_form_cart_submit');

        product_form_cart_submit.find('[data-loader]').addClass('hide');
        product_form_cart_submit.find('[data-add-to-cart-text]').removeClass('hide');
    });

    var product_hero_images_slider_el = $('#product_hero_images_slider');
    var activePHSIndex = product_hero_images_slider_el.find('.swiper-slide[data-active-slide]').index();

    var product_hero_images_slider_child = new Swiper('#product_hero_images_slider_child', {
        slidesPerView: 4,
        spaceBetween: 15,
        direction: 'vertical',
        loop: false,
        observer: true,
        observeParents: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.child-navs .swiper-button-next',
            prevEl: '.child-navs .swiper-button-prev',
        },
    });

    var product_hero_images_slider = new Swiper('#product_hero_images_slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide : (activePHSIndex >= 0 ? activePHSIndex : 0),
        pagination: {
            el: '#product_hero_images_slider .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: false,
        thumbs: {
            swiper: product_hero_images_slider_child
        }
    });

   
    document.addEventListener("updateswiper", () => {
      console.log('tesst')
        product_hero_images_slider.update();
        product_hero_images_slider_child.update();
    });
   
  
    $('.video-player-wrapper').click(function () {
        var video = $(this).find('video').get(0);
        var video_btn = $(this).find('.video-play-btn');
        var video_poster = $(this).find('.video-poster');

        if(!$(this).data('played')) {
            $(this).data('played', 1);
            video_poster.fadeOut(100);
        }

        if(video)
        {
            if(video.paused){
                video.play();
                video_btn.fadeOut(100);
            }else{
                video.pause();
                video_btn.fadeIn(100);
            }
        }
    });

    $('.video-player-wrapper video').on('ended', function () {
        $(this).closest('.video-player-wrapper').find('.video-play-btn').fadeIn(100);
    });

    new Swiper('#blog_reviews_section .swiper-container', {
        slidesPerView: 1,
        navigation:{
            nextEl: '#blog_reviews_section .swiper-button-next',
            prevEl: '#blog_reviews_section .swiper-button-prev'
        }
    });

    var sp_slider_el = document.querySelector('.similar-products .slider');

    if(sp_slider_el && 'swiper' in sp_slider_el)
    {
        var sp_swiper_params = sp_slider_el.swiper.passedParams;
        if(sp_swiper_params.el){
            delete sp_swiper_params.el;
        }

        sp_slider_el.swiper.destroy();

        var sp_swiper_wrapper = $('.similar-products .slider .swiper-wrapper');
        var sp_swiper_slides = sp_swiper_wrapper.find('.swiper-slide');

        theme.arraySuffle(sp_swiper_slides);

        sp_swiper_wrapper.html('');

        sp_swiper_slides.each(function () {
            sp_swiper_wrapper.append($(this));
        });

        new Swiper('.similar-products .slider', sp_swiper_params);
    }

    $(document).on('click', '.tgi-list > li .tgi-trigger', function () {
       var tgi_item = $(this).closest('li');
        $(this).toggleClass('open');
       // if($(window).width() > 1023){
       //     return;
       // }

       $(this).siblings('.tgi-content').slideToggle();

       // if(tgi_item.is('.open')) {
       //     tgi_item.find('.tgi-content').slideUp();
       //     tgi_item.removeClass('open');
       // }else{
       //     tgi_item.find('.tgi-content').slideDown();
       //     tgi_item.addClass('open');
       // }
    });

    $(document).on('variantChange', function (e) {
       if(e.detail && e.detail.variant)
       {
           var productVariantData = e.detail.variant;

           $('.product-toolbar .product-variant-title').html(productVariantData.title);

           if(productVariantData.available && ('Currency' in theme && 'formatMoney' in theme.Currency))
           {
             var allproductdata = $('.all-variant-data').html();
               var addToCartLabel = (theme.strings.addToCart || 'Add to cart');
               var addToCartButtonText = '<span class="product-add-to-cart-text-price">'+ theme.Currency.formatMoney(productVariantData.price) +'</span> | ' + addToCartLabel;
               $('.product-form__cart-submit [data-add-to-cart-text], .product-toolbar .product_form_cart_submit [data-add-to-cart-text]').html(addToCartButtonText);
               $('.price__pricing-group').html(theme.Currency.formatMoney(productVariantData.price));
               
           }

           
           if(productVariantData.featured_media)
           {
                product_hero_images_slider_el.find('.swiper-slide').each(function () {
                    if($(this).data('id') == productVariantData.featured_media.id){
                        product_hero_images_slider.slideTo($(this).index());
                    }
                });
           }

           if(productVariantData.featured_image)
           {
               var productToolbarImage = $(".product-toolbar .product-image img");

               if(productToolbarImage.length && ('Images' in theme && 'switchImage' in theme.Images))
               {
                   theme.Images.switchImage(
                       productVariantData.featured_image,
                       productToolbarImage[0],
                       function (newImageSizedSrc, newImage, element) {
                           $(element).attr('src', newImageSizedSrc);
                       }
                   );
               }
           }
       }
    });

    var pToolbar = $('.product-template__container .product-toolbar');
    var pHeader = $('.product-template__container .header-section');

    if(pToolbar.length && pHeader.length)
    {
        var pHeaderOffsetTop = pHeader.offset().top;
        var pHeaderHeight = pHeader.outerHeight();

        function initStickyProductToolbar()
        {
            var curScrollTop = $(document).scrollTop();
            if(curScrollTop > (pHeaderOffsetTop + pHeaderHeight)){
                if(!pToolbar.is('.sticky')){
                    pToolbar.addClass('sticky');
                }
            }else{
                pToolbar.removeClass('sticky');
            }
        }

        initStickyProductToolbar();
        $(document).on('scroll', initStickyProductToolbar);
    }

    $(document).on('click', '.product-toolbar .product_form_cart_submit', function (e) {
        e.preventDefault();

        var product_form_cart_submit = $('#product_form_cart_submit');

        if(product_form_cart_submit.is('[aria-disabled=true]')){
            return;
        }

        product_form_cart_submit.trigger('click');

        $(this).find('[data-loader]').removeClass('hide');
        $(this).find('[data-add-to-cart-text]').addClass('hide');
    });

    $('.marquee').marquee({
        duration: 26000,
        gap: 10,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true
    });

    function parallaxVerticalAnimationHeroSliderAssets()
    {
        $('.hero-slider .slider-assets .asset').each(function () {
            let top = parseFloat($(this).css('top'));
            let top1 = top - getNumber(5,15);
            let top2 = top + getNumber(5,15);
            let delay = getNumber(1500,2500);
            let thisA = $(this);

            function loopAnimation(){
                thisA.animate({top:top1},delay).animate({top:top2},delay, loopAnimation);
            }

            loopAnimation();
        });
    }

    $(window).on('load', function () {
        parallaxVerticalAnimationHeroSliderAssets();
    });

    var enableGalleryPageLoadMore = true;

    if (enableGalleryPageLoadMore)
    {
        var triggered = false;

        function ScrollExecute()
        {
            var gallery_items_loader_trigger = $('#gallery_items_loader_trigger');
            let gallery_items_load_url = gallery_items_loader_trigger.data("load-url");

            if(!gallery_items_loader_trigger.length){
                return;
            }

            if ( ((gallery_items_loader_trigger.offset().top - $(window).scrollTop()) < 800) && (triggered == false) )
            {
                triggered = true;

                $.ajax({
                    url: gallery_items_load_url,
                    type: 'GET',
                    beforeSend: function() {

                    },
                    success: function(respone)
                    {
                        var pageContent = $(respone);
                        var itemsHtml = $.trim( pageContent.find('.gallery-items-section .items_wrapper').html() );

                        if(itemsHtml)
                        {
                            $('.gallery-items-section .items_wrapper').append(itemsHtml);

                            var check_gallery_items_loader_trigger = pageContent.find('#gallery_items_loader_trigger');

                            if(check_gallery_items_loader_trigger.length){
                                gallery_items_loader_trigger.data('load-url', check_gallery_items_loader_trigger.data('load-url'));
                            }else{
                                gallery_items_loader_trigger.remove();
                            }
                        }

                        triggered = false
                    }
                });
            }
        }

        $(window).scroll(function () {
            ScrollExecute();
        });
    }

    var galleryFiltersToolbar = $('.gallery-filters-toolbar');
    var galleryHeaderSection = $('.gallery-header-section');

    function doGalleryFilter()
    {
        var filtersData = gallery_header_filters_form.serializeArray();
        var tagged = [];

        if(filtersData.length)
        {
            for(var i=0; i<filtersData.length; i++)
            {
                if(filtersData[i].value != '0'){
                    tagged.push(filtersData[i].value);
                }
            }
        }

        window.location.href = theme.shop_url + '/blogs/gallery' + (tagged.length ? '/tagged/' + tagged.join('+') : '');
    }

    if (galleryHeaderSection.length)
    {
        new Swiper('.gallery-header-section .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 20
        });

        var gallery_header_filters = $('.gallery-header-section .filters-wrapper .filter-item select');
        var gallery_header_filters_form = $('#gallery_header_filters_form');

        gallery_header_filters.select2({
            minimumResultsForSearch: -1,
            placeholder: 'Select an option',
        });

        gallery_header_filters.on('select2:select', function (e) {
            var data = e.params.data;
            console.log(data);
            doGalleryFilter();
        });
    }

    if (galleryFiltersToolbar.length)
    {
        var gallery_toolbar_filters = $('.gallery-filters-toolbar .filters-wrapper .filter-item select');
        var gallery_toolbar_filters_options = {
            minimumResultsForSearch: -1,
            placeholder: 'Select an option',
            dropdownAutoWidth: true,
            width: 'auto'
        };

        gallery_toolbar_filters.select2(gallery_toolbar_filters_options);

        $(window).on('load', function(){
            if($(window).width() < 1023){
                gallery_toolbar_filters.select2('open').select2('close');
            }
        });

        gallery_toolbar_filters.on('select2:select', function (e) {
            var data = e.params.data;
            var filterName = e.currentTarget.name;

            if(filterName)
            {
                var filterElement = $('.gallery-header-section .filters-wrapper .filter-item').find('select[name='+filterName+']');

                filterElement.val(data.id);
                filterElement.select2().trigger('change');

                doGalleryFilter();
            }
        });

        var galleryHeaderSectionTopPos = galleryHeaderSection.offset().top;
        var galleryHeaderSectionHeight = galleryHeaderSection.outerHeight();

        function initStickyGalleryFiltersToolbar()
        {
            var curScrollTop = $(document).scrollTop();

            if (curScrollTop > (galleryHeaderSectionTopPos + galleryHeaderSectionHeight)) {
                if (!galleryFiltersToolbar.is('.sticky')) {
                    galleryFiltersToolbar.addClass('sticky');
                }
            } else {
                galleryFiltersToolbar.removeClass('sticky');
            }
        }

        initStickyGalleryFiltersToolbar();
        $(document).on('scroll', initStickyGalleryFiltersToolbar);
    }

    var productPopupViewerTemplate = $('#productPopupViewerTemplate');
    var collectionPopupViewerTemplate = $('#collectionPopupViewerTemplate');

    $('script[data-script-template]').each(function (index) {
        var tpmlObj = $(this);
        var tmplUrl = tpmlObj.data('src');
        if (tmplUrl) {
            $.get(tmplUrl, function (data) {
                tpmlObj.html(data);
            });
        }
    });

    $(document).on('click', '.gallery_popup_wrapper .close_btn', galleryPopupClose);

    $(document).keyup(function (e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            galleryPopupClose()
        }
    });

    $(document).on('click', '.gallery_popup_wrapper', function(){
        galleryPopupClose();
    });

    $(document).on('click', '.gallery_popup_wrapper .inner_wrapper', function(e){
        e.stopPropagation();
    });

    $(document).on('click', '.gallery-items-section .item[data-product]', function (e) {
        e.preventDefault();

        if (!productPopupViewerTemplate.length) {
            return;
        }

        var product_id = parseInt($(this).data('product'));

        if (product_id > 0)
        {
            $.ajax({
                url: 'https://forms.byrobynblair.com/getProductApi.php',
                dataType: 'json',
                data: {
                    p: product_id
                },
                beforeSend: function () {
                    jQuery('#productPopupViewer').html(jQuery('#galleryPopupLoader').html()).show();
                    $(document.body).addClass('none-vis');
                },
                success: function (response) {
                    if(!response.product){
                        console.error('Missing product object in response');
                        console.log(response);
                        galleryPopupClose();
                        return;
                    }

                    $.extend(response.product, {
                        asset_url: theme.asset_url.replace(/\?v=\d+$/, ''),
                        shop_url: theme.shop_url
                    });

                    var galleryPopupTmpl = $('#productPopupViewerTemplate').tmpl(response.product, galleryPopupTmplOptions);
                    $('#productPopupViewer').html('<div class="gallery_popup_wrapper">' + galleryPopupTmpl.html() + '</div>').show();
                },
                error: function(){
                    galleryPopupClose();
                }
            })
        }
    });

    $(document).on('click', '.gallery_popup_wrapper .product_add_to_cart_btn', function () {
        var addToCartBtn = $(this);

        var product_id = parseInt(addToCartBtn.data('product'));

        showTooltipAddToCart();

        if (!isNaN(product_id))
        {
            var addToCartData = {
                items: [
                    {
                        id: product_id,
                        quantity: 1,
                    }
                ]
            }

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: addToCartData,
                dataType: 'json',
                beforeSend: function () {
                    addToCartBtn.addClass('loading').prop('disabled', true);
                },
                success: function (json) {
                    fetch('/cart.js')
                    .then(function(response){
                        return response.json();
                    })
                    .then(function (json) {
                        $('.cart-qty').html(json.items.length);
                        return json;
                    });
                    galleryPopupClose();
                    $(document).trigger('galleryPopupProductAddToCart', [json]);
                },
                error: function (XMLHttpRequest) {
                    console.error('Add To Cart Request Error: ' + XMLHttpRequest.responseText);
                },
                complete: function () {
                    addToCartBtn.removeClass('loading').prop('disabled', false);
                }
            })
        }
    });

    $(document).on('click', '.gallery-items-section .item[data-page]', function (e) {
        e.preventDefault();

        var page = $.trim($(this).data('page'));

        var pageCustomizePopupViewerTemplate = $('#pageCustomizePopupViewerTemplate');
        var pageCollaborationsPopupViewerTemplate = $('#pageCollaborationsPopupViewerTemplate');

        if(page == 'customize' && pageCustomizePopupViewerTemplate.length)
        {
            $(document.body).addClass('none-vis');
            $('#productPopupViewer').html(pageCustomizePopupViewerTemplate.html()).show();
        }

        if(page == 'collaborations' && pageCollaborationsPopupViewerTemplate.length)
        {
            $(document.body).addClass('none-vis');
            $('#productPopupViewer').html(pageCollaborationsPopupViewerTemplate.html()).show();
        }
    });

    $(document).on('click', '.gallery-items-section .item[data-collection]', function (e) {
        e.preventDefault();

        if (!collectionPopupViewerTemplate.length) {
            return;
        }

        var collection_id = parseInt($(this).data('collection'));

        if (collection_id > 0)
        {
            $.ajax({
                url: 'https://forms.byrobynblair.com/getCollectionApi.php',
                dataType: 'json',
                data: {
                    c: collection_id
                },
                beforeSend: function () {
                    jQuery('#productPopupViewer').html(jQuery('#galleryPopupLoader').html()).show();
                    $(document.body).addClass('none-vis');
                },
                success: function (response) {
                    if(!response.collection){
                        console.error('Missing collection object in response');
                        console.log(response);
                        galleryPopupClose();
                        return;
                    }

                    $.extend(response.collection, {
                        asset_url: theme.asset_url.replace(/\?v=\d+$/, ''),
                        shop_url: theme.shop_url
                    });

                    var galleryPopupTmpl = $('#collectionPopupViewerTemplate').tmpl(response.collection, galleryPopupTmplOptions);
                    $('#productPopupViewer').html('<div class="gallery_popup_wrapper">' + galleryPopupTmpl.html() + '</div>').show();
                },
                error: function(){
                    galleryPopupClose();
                }
            })
        }
    });

    new Swiper('#selected-products-slider .swiper-container', {
        slidesPerView: 2,
        spaceBetween: 16,
        pagination:{
            el: '#selected-products-slider-wrapper .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints:{
            1024:{
                spaceBetween: 50,
                slidesPerView: 4,
            }
        }
    });

    new Swiper('#latest-products-slider .swiper-container', {
        slidesPerView: 2,
        spaceBetween: 16,
        pagination:{
            el: '#latest-products-slider-wrapper .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints:{
            1024:{
                spaceBetween: 50,
                slidesPerView: 4,
            }
        }
    });

    $(document).on('click', '#mobile_search_submit_btn', function (){
        console.log('mobile_search_input', 5555);
    });

    $('.size_desc_wrapper .size_desc_head').on('click', function (){
        $(this).parent().toggleClass('open');
        $(this).siblings('.size_description').slideToggle();
    })

  if($('body').hasClass('template-product')){
   $('.price__pricing-group').html(theme.Currency.formatMoney($('body').data('price')));
  }
   

});